import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import VendorDashboard from "../views/Dashboard/VendorDashboard.js";
import VehicleDetails from "../views/Company/VehicleDetails.js";
import InspectionReportView from "../views/Company/InspectionReportView.js";
import workorder from "../views/Defects/workorder.jsx";
import Details from "../pages/inspectionDetails";
import InspectionPage from "../inspection/inspetionsPage";
import InspectionDetail from "../inspection/inspectionDetails";
import InspectionList from "../inspection/inspectionList";
import VendorWork from "../views/Dashboard/VendorWork.js";

class VendorRoutes extends Component {
  render() {
    let { history } = this.props;
    return (
      <Switch>
        <Route exact path="/vendor" component={VendorDashboard} />
        <Route exact path="/vendor/customer/:cId" component={VendorWork} />
        <Route
          exact
          path="/vendor/customer/:cId/vehicle/:vId"
          component={VehicleDetails}
        />
        <Route
          exact
          path="/vendor/customer/:cId/vehicle/inspection/:iId"
          component={InspectionReportView}
        />
        <Route
          exact
          path="/vendor/customer/:cId/defects/work/order/:dId"
          component={workorder}
        />
        <Route
          exact
          path="/vendor/customer/:cId/inspection/new/details/:id"
          history={history}
          component={InspectionDetail}
        />
        <Route
          exact
          path="/vendor/customer/:cId/inspection/new/start/inspection/:id/:type"
          history={history}
          component={InspectionList}
        />
      </Switch>
    );
  }
}

export default VendorRoutes;



// WEBPACK FOOTER //
// ./src/vendors/VendorRoutes.js